/**
 * @file One goal's attainment bar: booked in the accent with quoted stacked
 * after it in the lighter accent, both as shares of the period goal and held
 * within the track. Consumers: the Overview team table's ATTAINMENT cells and
 * the Home tiles. The bar adds booked and quoted, so it carries "Projection:
 * booked + quoted" as its tooltip and `aria-label`; while quoted does not
 * answer it draws booked alone, unlabelled.
 */
import { FC } from 'react';
import { Progress, Tooltip, theme } from 'antd';

import { analyticsAttainmentPercent } from '@/analytics';
import type { GoalProgress } from '@/analytics';

import FlexBox from '../atoms/FlexBox';

const PROJECTION = 'Projection: booked + quoted';

export const AnalyticsAttainmentBar: FC<{ progress: GoalProgress }> = ({
  progress,
}) => {
  const { token } = theme.useToken();
  const booked = analyticsAttainmentPercent(progress.attainment);
  if (progress.projection === null)
    return (
      <Progress
        percent={booked}
        showInfo={false}
        size="small"
        strokeColor={token.colorPrimary}
      />
    );
  return (
    <Tooltip title={PROJECTION}>
      <FlexBox aria-label={PROJECTION}>
        <Progress
          percent={analyticsAttainmentPercent(progress.projection)}
          success={{ percent: booked, strokeColor: token.colorPrimary }}
          showInfo={false}
          size="small"
          strokeColor={token.colorPrimaryBorderHover}
        />
      </FlexBox>
    </Tooltip>
  );
};
